export const TEST_ID = 'outlinedButton';
